export enum RouteEndCondition {
    ArriveAllVisits,
    ArriveEndLocation
}

